import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=503b81fe&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
import style0 from "./Admin.vue?vue&type=style&index=0&id=503b81fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503b81fe",
  null
  
)

export default component.exports